import "./App.css";
import { ThemeProvider } from "./logic/themeContext";
import { themeTime } from "./logic/theme";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Home, Weather } from "./page/index";
function App() {
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");

    if (!savedTheme) {
      themeTime();

      const interval = setInterval(themeTime, 100000);

      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/weather" element={<Weather />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
